import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

export const TERMS = { RD: "Rimessa diretta", "30DF": "30 gg data fattura", "60DF": "60 gg data fattura", "90DF": "90 gg data fattura", "30FM": "30 gg fine mese",
  "60FM": "60 gg fine mese", "90FM": "90 gg fine mese", "120FM": "120 gg fine mese", "30-60FM": "30/60 gg fine mese", "30-60-90FM": "30/60/90 gg fine mese" };
export const METHODS = { MP05: "Bonifico", MP12: "RIBA", MP19: "SEPA Direct Debit", MP01: "Contanti", MP02: "Assegno", MP08: "Carta di pagamento" };
export const SDI = { TO_SEND: ["Da inviare", "bg-amber-100 text-amber-900"], SENT: ["Inviata", "bg-sky-100 text-sky-900"], DELIVERED: ["Consegnata", "bg-emerald-100 text-emerald-900"], REJECTED: ["Scartata", "bg-red-600 text-white"] };
export const PAY = { UNPAID: ["Da pagare", "bg-amber-100 text-amber-900"], PARTIAL: ["Parziale", "bg-sky-100 text-sky-900"], PAID: ["Saldata", "bg-emerald-100 text-emerald-900"], NA: ["—", ""] };
export const DOC = { TD01: "Fattura", TD04: "Nota di credito" };
export const NATURES = { "N6.3": "N6.3 Reverse charge subappalto", N1: "N1 Escluse art. 15", "N2.2": "N2.2 Non soggette", N4: "N4 Esenti" };
export const euro = (n) => (n ?? 0).toLocaleString("it-IT", { style: "currency", currency: "EUR" });

export const Chip = ({ map, value, testId }) => {
  const [label, cls] = map[value] || ["—", ""];
  return <span data-testid={testId} className={`whitespace-nowrap px-1.5 py-0.5 text-[11px] font-semibold uppercase ${cls}`}>{label}</span>;
};

export const download = async (url, params, filename) => {
  try {
    const r = await api.get(url, { params, responseType: "blob" });
    const href = URL.createObjectURL(r.data);
    const a = document.createElement("a");
    a.href = href;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(href), 1000);
  } catch (e) {
    const msg = e?.response?.data instanceof Blob ? JSON.parse(await e.response.data.text()).detail : errMsg(e);
    toast.error(msg);
  }
};
